import { SaleTypeForPlan } from "@/lib/gql/__generated__/graphql";

import type { FormOptionType } from "@/components/ui/form/_types/type";

/**
 * プラン限定のディスカウントにするかの選択肢
 */
export const SaleTypeForPlanOptions = [
	{ id: SaleTypeForPlan.Ordinary, label: "常に販売", value: SaleTypeForPlan.Ordinary },
	{ id: SaleTypeForPlan.Limited, label: "特定のプランでのみ適用する", value: SaleTypeForPlan.Limited },
] satisfies FormOptionType[];
